// Normalize
import { currency } from '../../constants/normalize'

export const normalize = (type, data) => {
  switch (type) {
    case 'percentage':
      return Math.round(data * 100) + '%'
      break;
    case 'time':
      if(!data) return '-'
      return Math.round(data) + 'h'
      break;
    case 'currency':
      return `R$ ${currency(String(Math.round(data)), false)}`
      break;
    default:
      return data
  }
}
